var exports = {
  "kR": "AssetSourceModal.module__cards___X04wT3",
  "KI": "AssetSourceModal.module__cardsSingle___X04wT3",
  "Nr": "AssetSourceModal.module__card___X04wT3",
  "Ie": "AssetSourceModal.module__cardIcon___X04wT3",
  "PY": "AssetSourceModal.module__cardLabel___X04wT3",
  "eX": "AssetSourceModal.module__cardHint___X04wT3",
};

module.exports = exports;
